import React from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'

const Loader = () => <CircularProgress size="1.5em" />

export default Loader
